import type { AgnosticIndexRouteObject } from '@remix-run/router';
import { type UIMatch, useMatches } from 'react-router-dom';

export const useTypedMatches = <TData>() =>
  useMatches() as UIMatch<TData, AgnosticIndexRouteObject['handle']>[];
